import React, { useEffect, useState } from "react";
import "./Desi_connect.css";
import { desi_connect_img } from "../../../../assets";
import useShimmer from "../../../../hooks/useShimmer";
import { fetchCmsDataApi } from "../../../../services/faqs";
import CmsShimmer from "../../../../shimmer/CMS/CmsShimmer";
import { toastMessage } from "../../../../utils/toastMessage";

const Desi_connect = () => {
  const [aboutData, setAboutData] = useState("");
  const [showShimmer, setShowShimmer] = useShimmer(CmsShimmer);

  const getPrivacyHandler = async () => {
    try {
      setShowShimmer(true);
      const { data } = await fetchCmsDataApi({ type: "ABOUT-US" });
      const { data: about, success, message } = data;
      if (success) {
        // toastMessage(message, "success", "privacy");
        setAboutData(about);
      } else {
        toastMessage(message, "error", "privacy");
      }
    } catch (e) {
      console.log("Login:-", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  useEffect(() => {
    getPrivacyHandler();
  }, []);

  return (
    <>
      <div className="About_about_connect">
        <div className="container_about_connect">
          <div className="desi_about_title">
            <h2>About Logical Chat</h2>
          </div>
        </div>

        {/* <div className="about_connect_img">
          <img src={desi_connect_img} />
        </div>

        <div className="desi_connect_content">
          <p>
            A group chat is a conversation that takes place among multiple
            participants in a messaging platform or app. It allows users to send
            and receive messages, images, videos, and other content to a
            designated group, making it easier to communicate and collaborate
            with friends, family, colleagues, or any other group of people.
            Group chats can vary in size and purpose, ranging from casual chats
            among friends to formal discussions in professional settings.
          </p>

          <p>
            Chats refer to real-time conversations conducted through various
            digital platforms, allowing users to exchange messages, multimedia,
            and information. Here’s a detailed look at what chats are, their
            types, features, and benefits:
          </p>

          <p>
            Chats refer to real-time conversations conducted through various
            digital platforms, allowing users to exchange messages, multimedia,
            and information. Here’s a detailed look at what chats are, their
            types, features, and benefits:
          </p>

          <p>
            A group chat is a conversation that takes place among multiple
            participants in a messaging platform or app. It allows users to send
            and receive messages, images, videos, and other content to a
            designated group, making it easier to communicate and collaborate
            with friends, family, colleagues, or any other group of people.
            Group chats can vary in size and purpose, ranging from casual chats
            among friends to formal discussions in professional settings.
          </p>
        </div> */}

        {showShimmer || (
          <p
            dangerouslySetInnerHTML={{
              __html: aboutData?.description,
            }}
          ></p>
        )}
      </div>
    </>
  );
};

export default Desi_connect;
